import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/ecfce773-a9fe-4e94-bab2-d0112175d36e',
    name: 'Issues',
    component: () => import('@/views/Issues')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
